var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessDeniedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99332 1.48667L3.66665 2.74C2.89998 3.02667 2.27332 3.93333 2.27332 4.74667V9.7C2.27332 10.4867 2.79332 11.52 3.42665 11.9933L6.29332 14.1333C7.23332 14.84 8.77998 14.84 9.71998 14.1333L12.5866 11.9933C13.22 11.52 13.74 10.4867 13.74 9.7V4.74667C13.74 3.92667 13.1133 3.02 12.3466 2.73333L9.01998 1.48667C8.45332 1.28 7.54665 1.28 6.99332 1.48667Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43331 8.96004L6.59998 6.12671",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39998 6.16003L6.56665 8.99337",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDeniedIcon);
export default __webpack_public_path__ + "static/media/AccessDeniedIcon.1fb7f73a9cf3495430cc148fa1cba692.svg";
export { ForwardRef as ReactComponent };